export default __webpack_public_path__ + "static/media/eg12D1Zr.77d85939.jpeg";